import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-quickbooks',
  template: `
    <sbnb-apps-detail-page
      name="Intuit Quickbooks"
      logoTile="/assets/images/apps/qb-business-affiliate.svg"
      [categories]="['Accounting']"
      [permissions]="[AppPermission.financialsRead]"
      [beta]="true"
      [helpArticles]="[
        {
          id: '10470010',
          title: 'Connecting your Accounting software with Hospitable',
        },
      ]">
      <ng-container description>
        <div class="flex gap-4">
          <p>
            Accounting integrations are available for those participating in a private pilot as a part of our Mogul
            plan.
          </p>
          <sbnb-alert-card context="positive" class="flex flex-col gap-2 text-base">
            <strong>Don't have QuickBooks yet?</strong>
            <div>Sign up for QuickBooks and save 30% on QuickBooks for 6 months!</div>
            <sbnb-button type="primary-teal" size="mini">
              <a href="https://quickbooks.partnerlinks.io/8slmaqe5fsju" target="_blank">Sign up for QuickBooks</a>
            </sbnb-button>
          </sbnb-alert-card>
        </div>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
})
export class QuickbooksComponent {
  public AppPermission = AppPermission;
}
